import { Col, Row, Badge, Rate } from "antd";
import React, { useState, useEffect } from "react";
import {
  CloseCircleOutlined,
  SearchOutlined,
  ShoppingCartOutlined,
  ArrowLeftOutlined,
  StarFilled,
  InfoCircleOutlined,
} from "@ant-design/icons";
import briefCase from "../assets/images/restaurant/suitcase_outline.svg";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { setRestaurant } from "../slices/restaurantCartSlice";
import { useCartNavigation } from "../hooks/useCartNavigation";

export const LocationWrapperMini = ({
  selectLoc,
  businessType,
  businessName,
  businessRating,
  onAboutClick,
}) => {
  const [isClicked, setIsClicked] = useState(false);
  const navigate = useNavigate();
  const { id: restaurantId } = useParams();
  const dispatch = useDispatch();

  const { handleCartClick, cartCount } = useCartNavigation(
    businessType,
    restaurantId
  );

  useEffect(() => {
    if (restaurantId) {
      dispatch(setRestaurant({ restaurantId, businessType }));
    }
  }, [dispatch, restaurantId, businessType]);

  const handleLocationWrapperSearch = () => {
    setIsClicked(!isClicked);
  };

  const handleBack = () => {
    navigate(`/${businessType}`);
  };

  return (
    <div
      style={{ height: "auto", minHeight: "auto", maxHeight: "auto" }}
      className="wrapperBg sticky top-0 z-50 py-3"
    >
      <Row justify={"middle"} className="h-[100%]">
        <Col xs={24}>
          <div className="items-center md:hidden gap-2 justify-between px-4 flex min-h-[50px]">
            <div className="flex items-center gap-3">
              <ArrowLeftOutlined
                style={{ fontSize: "24px", cursor: "pointer" }}
                onClick={handleBack}
              />
              {businessName && !isClicked && (
                <div className="flex flex-col">
                  <p className="font-bold truncate text-3xl max-w-[215px]">
                    {businessName}
                  </p>
                </div>
              )}
            </div>

            <div
              className={` ${
                isClicked
                  ? "flex justify-between border-2 border-[#00000073] rounded-full py-2 px-3 bg-transparent flex-1 ml-4"
                  : ""
              } `}
            >
              <input
                type="text"
                className={` ${
                  isClicked ? "block" : "hidden"
                } w-full bg-transparent focus:outline-none text-2xl`}
                placeholder="Search"
              />
              <div className="flex items-center gap-4">
                {isClicked ? (
                  <CloseCircleOutlined
                    style={{ fontSize: "22px" }}
                    onClick={handleLocationWrapperSearch}
                  />
                ) : (
                  <SearchOutlined
                    style={{ fontSize: "22px" }}
                    onClick={handleLocationWrapperSearch}
                  />
                )}
                <InfoCircleOutlined
                  style={{
                    fontSize: "22px",
                    cursor: "pointer",
                    color: "#000",
                  }}
                  onClick={onAboutClick}
                />
                <Badge count={cartCount} offset={[0, 5]} size="small">
                  <ShoppingCartOutlined
                    style={{
                      fontSize: "22px",
                      cursor: "pointer",
                      color: "#000",
                    }}
                    onClick={handleCartClick}
                  />
                </Badge>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
